module.exports = "<div id=\"member-container\">\n    <div id=\"logged-header\">\n        <ez-member-menu></ez-member-menu>\n    </div>\n    <div id=\"logged-content\">\n        <router-outlet></router-outlet>\n    </div>\n</div>\n<ez-popup></ez-popup>\n<ez-loader></ez-loader>\n<ez-toast></ez-toast>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/member/member.component.html
// module id = 476
// module chunks = 0